// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageOffers_container__J0Ij3","offers":"LandingPageOffers_offers__MEuLR","text":"LandingPageOffers_text__wf_S5"};